import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WebshopSessionService } from '../services/webshop-session.service';

/**
 * Keeps the internal tool pages off-limits to customers. The session signal is only populated
 * once the app has asked the ERP who we are, so a direct navigation (or a page reload) has to
 * wait for that call before it can decide.
 */
export const internalUserGuard: CanActivateFn = async () => {
  const session = inject(WebshopSessionService);
  const router = inject(Router);

  // Bootstrap no longer waits for the session request, so on a direct navigation the answer
  // is usually still on the wire: wait for that one rather than issuing a second.
  await session.whenReady();
  if (session.isInternalUser()) return true;

  const info = await session.getWebshopSessionCustomerPersonId();
  return info.isInternalUser ? true : router.createUrlTree(['/']);
};
